module.exports = __webpack_public_path__ + "1aacda5debf0063d2884138c529fa908.png";